const FormFieldInputRange = ({
    type = 'text',
    label,
    fieldName,
    value,
    defaultValue,
    stateObject,
    updateStateObject,
    required = false,
    formatValue = null,
    className = '',
    onChange = null,
    additionalProps = {},
    readOnly = false,
    description = ''
}) => {
    const handleChange = (e) => {
        updateStateObject({
            ...stateObject,
            [fieldName]: formatValue ? formatValue(e.target.value) : e.target.value
        })

        if (onChange) {
            onChange(e)
        }
    }

    return (
        <div className={`formField ${className}`}>
            {label && <label>{label}{required ? "*" : ""}: </label>}
            {description && <span className="formField-description">{description}</span>}
            <input
                type={type}
                defaultValue={defaultValue}
                value={value}
                onChange={handleChange}
                required={required}
                name={fieldName}
                {...additionalProps}
                readOnly={readOnly}
            />
            {type === 'range' && <div style={{lineHeight: 1}}>{stateObject[fieldName]}</div>}
        </div>
    )
}

export default FormFieldInputRange;